import { EnrollApi } from 'api';
import { useAuthMutation, useQueryClient } from 'queries/query';
import { KEY } from './keys';

function useAddVolunteer() {
  const queryClient = useQueryClient();
  return useAuthMutation(EnrollApi.addVolunteer, {
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [KEY],
      });
    },
  });
}

export default useAddVolunteer;
